import React from 'react';
import { useWallet } from '../../context/WalletContext';
import NeonButton from './NeonButton';
import GlassCard from './GlassCard';
import { PLAN_META, RANK_LABELS } from '../../utils/constants';

const FEATURES = [
  { icon: '⧗', title: 'Daily Farming',    text: 'Earn from 0.10% up to 1.00% per day, compounding across four plan tiers.' },
  { icon: '⊕', title: '30-Level Network', text: 'Earn income across a 30-level referral tree. Rank up to 50% differential income.' },
  { icon: '⧖', title: 'PinkSale Locked',  text: '3, 5, and 7 year plans are backed by verifiable PinkSale token locks.' },
  { icon: '★', title: '10X Contributor',  text: 'Every 7-year investment mints a Contributor record — 10X USD payout over 5 years.' },
  { icon: '▲', title: '9-Rank Ladder',    text: 'Grow legs to unlock higher rank income tiers, up to Icon (R9).' },
  { icon: '◆', title: 'On-Chain First',   text: 'All state lives in the storage contract. Pull-based accrual, no admin custody.' },
];

const ConnectPrompt = () => {
  const { connectInjected, connecting } = useWallet();

  return (
    <div className="landing">
      {/* HERO */}
      <div className="landing-hero">
        <div className="landing-hero-orbit">
          <div className="hex-loader-ring r2" />
          <div className="hex-loader-ring r1" />
          <div className="hex-loader-ring" />
          <div className="hex-loader-pulse" />
          <div className="hex-loader-pulse p2" />
          <div className="hex-loader-pulse p3" />
          <div className="hex-loader-orbit-hex o1" />
          <div className="hex-loader-orbit-hex o2" />
          <div className="hex-loader-orbit-hex o3" />
          <img src="/Logo.png" alt="Graphenex" className="landing-logo animate-breathe" />
        </div>

        <div className="landing-hero-text">
          <div className="badge b-cyan mb-2">◆ NEXT-GENERATION DeFi ECOSYSTEM</div>
          <h1 className="landing-title">
            <span className="grx-text-gradient">GRAPHENEX</span>
          </h1>
          <div className="landing-sub">
            A carbon-strong, on-chain investment protocol. Four farming plans, thirty referral levels,
            nine rank tiers — powered by the <span className="text-neon">GRX</span> token.
          </div>
          <div className="landing-cta">
            <NeonButton size="lg" loading={connecting} onClick={connectInjected}>
              <span style={{ marginRight: 8 }}>◆</span> Connect Wallet
            </NeonButton>
            <a href="#plans" className="neon-btn btn-ghost btn-lg" style={{ textDecoration: 'none' }}>
              View Plans
            </a>
          </div>
          <div className="landing-chip-row">
            <span className="badge">Trust Wallet</span>
            <span className="badge">MetaMask</span>
            <span className="badge">Binance</span>
            <span className="badge">SafePal</span>
            <span className="badge">WalletConnect</span>
          </div>
        </div>
      </div>

      {/* PLANS */}
      <div id="plans" className="landing-section">
        <div className="landing-section-header">
          <div className="mono uppercase text-dim" style={{ fontSize: 11, letterSpacing: '0.2em' }}>◆ INVESTMENT PLANS</div>
          <h2 className="mt-1">Choose Your Node</h2>
        </div>
        <div className="plan-grid">
          {PLAN_META.map((p, i) => (
            <div key={p.id} className="plan-card animate-slide-up" style={{ animationDelay: (0.1 * i) + 's' }}>
              <div className="plan-name">{p.name}</div>
              <div className="plan-tag">{p.tag}</div>
              <div className="plan-apr">{(p.dailyBps / 100).toFixed(2)}%</div>
              <div className="plan-apr-sub">daily · Lock {p.lockYears || 0}y</div>
              {p.id === 3 && <div className="badge b-cyan" style={{ marginTop: 12 }}>10X CONTRIBUTOR</div>}
            </div>
          ))}
        </div>
      </div>

      {/* FEATURES */}
      <div className="landing-section">
        <div className="landing-section-header">
          <div className="mono uppercase text-dim" style={{ fontSize: 11, letterSpacing: '0.2em' }}>◆ ECOSYSTEM</div>
          <h2 className="mt-1">Built On Graphene</h2>
        </div>
        <div className="grid grid-3">
          {FEATURES.map((f, i) => (
            <GlassCard key={i} className="animate-slide-up" style={{ animationDelay: (0.05 * i) + 's' }}>
              <div className="feature-icon">{f.icon}</div>
              <div className="feature-title">{f.title}</div>
              <div className="feature-text">{f.text}</div>
            </GlassCard>
          ))}
        </div>
      </div>

      {/* RANKS */}
      <div className="landing-section">
        <div className="landing-section-header">
          <div className="mono uppercase text-dim" style={{ fontSize: 11, letterSpacing: '0.2em' }}>◆ RANK PROGRESSION</div>
          <h2 className="mt-1">Nine Tiers to the Top</h2>
        </div>
        <div className="rank-strip">
          {RANK_LABELS.slice(0, 10).map((label, i) => i > 0 && (
            <div key={i} className="rank-strip-item">
              <div className="rank-strip-badge">R{i}</div>
              <div className="rank-strip-name">{label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="landing-section landing-cta-block">
        <div className="landing-cta-inner">
          <img src="/Logo.png" alt="" className="landing-cta-logo animate-breathe" />
          <h2 className="grx-text-gradient" style={{ margin: 0 }}>Join the Network</h2>
          <div className="landing-sub" style={{ margin: '10px 0 20px' }}>
            Connect your wallet to register, invest, and start earning today.
          </div>
          <NeonButton size="lg" loading={connecting} onClick={connectInjected}>Connect Wallet</NeonButton>
        </div>
      </div>
    </div>
  );
};

export default ConnectPrompt;
